export const DEFAULT_INFOS = {
	name: '',
	description: '',
	audience: '',
	theme: '',
	filenameTemplate: '',
	genreId: undefined,
	aiModelIds: [],
};

export const DEFAULT_VIGNETTES = {
	'VIGNETTE-PROGRAM-INTRO': [],
	'VIGNETTE-PROGRAM-OUTRO': [],
	'VIGNETTE-BLOCK-INTRO': [],
	'VIGNETTE-BLOCK-OUTRO': [],
	'VIGNETTE-BREAK': [],
};
